import * as tslib_1 from "tslib";
// Core components
import { OnInit } from "@angular/core";
// Third party components
import { FieldType } from '@ngx-formly/core';
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { ConfigService } from 'src/app/shared/services/config.service';
// Custom components
var AttachmentsTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(AttachmentsTypeComponent, _super);
    /**
     * Class constructor
     */
    function AttachmentsTypeComponent(configService, propertiesService) {
        var _this = _super.call(this) || this;
        _this.configService = configService;
        _this.propertiesService = propertiesService;
        _this.files = [];
        _this.attachments = [];
        _this.subscriptions = [];
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    AttachmentsTypeComponent.prototype.ngOnInit = function () {
        var _this = this;
        // General purpose
        if (this.model.files) {
            this.model.files.forEach(function (file) {
                var path = file.path.replace(/src[\\\/]assets/g, 'public');
                var url = "";
                if (path.substring(0, 22) === "https://app.archedi.it") {
                    url = path;
                    // https://app.archedi.it/documents/c15bc5eb-bd5a-11e7-a685-000c29dd368f/005073000000S000001C.pdf
                    // url = `https://api.archedi.it/uploads/properties/${propertyId}/documents/${filename}`;
                }
                else {
                    url = _this.configService.apiHost + "/" + path;
                }
                url = _this.configService.apiHost + "/" + path;
                var newFile = {
                    name: file.originalName,
                    url: url,
                };
                _this.files.push(newFile);
            });
        }
        // Communication's attachments
        if (this.model.attachments) {
            this.model.attachments.forEach(function (att) {
                var path = att.path.replace(/src[\\\/]assets/g, 'public');
                var url = "";
                if (path.substring(0, 22) === "https://app.archedi.it") {
                    url = path;
                }
                else {
                    url = _this.configService.apiHost + "/" + path;
                }
                var newAttachment = {
                    name: att.originalName,
                    url: url,
                };
                _this.attachments.push(newAttachment);
            });
        }
        // Balance's InvoiceFile (only 1)
        if (this.model.invoiceFile) {
            var files = this.model.invoiceFile;
            var propertyId = this.model.property ? this.model.property._id : undefined;
            if (!propertyId) {
                return;
            }
            if (Array.isArray(files)) {
                files.forEach(function (file) {
                    var path = file.path;
                    var url = "";
                    // if (path.substring(0, 22) === "https://app.archedi.it") {
                    //   url = path;
                    // } else {
                    //   url = `${this.configService.apiHost}/${path}`;
                    // }
                    url = _this.configService.apiHost + "/" + path;
                    var newFile = {
                        name: file.originalName,
                        url: url,
                    };
                    _this.files.push(newFile);
                });
            }
            else {
                var path = files.path; //.replace("temp", `properties/${propertyId}/balances`);
                var url = "";
                // if (path.substring(0, 22) === "https://app.archedi.it") {
                //   url = path;
                // } else {
                //   url = `${this.configService.apiHost}/${path}`;
                // }
                url = this.configService.apiHost + "/" + path;
                var newFile = {
                    name: files.originalName,
                    url: url,
                };
                this.files.push(newFile);
            }
        }
    };
    return AttachmentsTypeComponent;
}(FieldType));
export { AttachmentsTypeComponent };
